import { cva } from "class-variance-authority";
/**
 * Radio container styles
 */
export const radioContainerVariants = cva("inline-flex items-start gap-3 cursor-pointer", {
    variants: {
        disabled: {
            true: "cursor-not-allowed opacity-[0.38]",
            false: "",
        },
    },
    defaultVariants: {
        disabled: false,
    },
});
/**
 * Radio button outer circle styles
 */
export const radioOuterVariants = cva([
    "relative",
    "flex",
    "items-center",
    "justify-center",
    "rounded-full",
    "border-2",
    "transition-all",
    "duration-md-short",
    "ease-md-standard",
    "flex-shrink-0",
], {
    variants: {
        size: {
            small: "w-4 h-4",
            medium: "w-5 h-5",
        },
        checked: {
            true: "border-primary",
            false: "border-on-surface-variant",
        },
        error: {
            true: "border-error",
            false: "",
        },
        disabled: {
            true: "",
            false: "group-hover:border-primary",
        },
    },
    compoundVariants: [
        {
            checked: true,
            error: true,
            className: "border-error",
        },
    ],
    defaultVariants: {
        size: "medium",
        checked: false,
        error: false,
        disabled: false,
    },
});
/**
 * Radio button inner dot styles
 */
export const radioInnerVariants = cva(["rounded-full", "transition-all", "duration-md-short", "ease-md-standard"], {
    variants: {
        size: {
            small: "w-2 h-2",
            medium: "w-2.5 h-2.5",
        },
        checked: {
            true: "bg-primary scale-100",
            false: "bg-transparent scale-0",
        },
        error: {
            true: "bg-error",
            false: "",
        },
    },
    compoundVariants: [
        {
            checked: true,
            error: true,
            className: "bg-error",
        },
    ],
    defaultVariants: {
        size: "medium",
        checked: false,
        error: false,
    },
});
/**
 * Radio label styles
 */
export const radioLabelVariants = cva("text-on-surface select-none", {
    variants: {
        size: {
            small: "text-sm",
            medium: "text-base",
        },
    },
    defaultVariants: {
        size: "medium",
    },
});
/**
 * Radio group container styles
 */
export const radioGroupVariants = cva("flex", {
    variants: {
        orientation: {
            horizontal: "flex-row flex-wrap",
            vertical: "flex-col",
        },
        gap: {
            default: "gap-4",
            none: "",
        },
    },
    defaultVariants: {
        orientation: "vertical",
        gap: "default",
    },
});
//# sourceMappingURL=radio.styles.js.map